module.exports = __webpack_public_path__ + "static/media/Tim Scanlon Headshot_1700136180958.3e4765f3.png";